import { isoToFormatDate } from "./formatTime";

const getTopText = (announcement) => {
  return announcement.top ? "✅" : "";
};

const addSearchedField = (announcements) => {
  announcements.forEach((a) => {
    if (a.searchedField) {
      return; // already has one
    }

    const searchedTexts = [
      getTopText(a),
      isoToFormatDate(a.createdAt, "yyyy/MM/dd HH:mm"),
    ];

    a.searchedField = searchedTexts.join(" ");
  });
};

// if is top, put at beginning of array
/**
 * Description
 * @param {Announcement[]} announcements
 * @returns {Announcement[]}
 */
const sortByTopField = (announcements) => {
  announcements.sort((a, b) => {
    return Number(b.top) - Number(a.top);
  });

  return announcements;
};

export { getTopText, addSearchedField, sortByTopField };
